export default "__VITE_ASSET__ecb19919__"